// import React from "react";
// import {
//   Paper,
//   Typography,
//   Grid,
//   Switch,
//   FormControlLabel,
//   Divider,
// } from "@mui/material";
// import { useForm } from "react-hook-form";
// import WSTextField from "../../Components/TextBox/WSTextBox";

// type ReceiptFormValues = {
//   shopName: string;
//   shopAddress: string;
//   shopPhone: string;

//   showCustomerName: boolean;
//   showPhone: boolean;
//   showDiscount: boolean;
//   showPaymentType: boolean;

//   footerMessage: string;
//   templateType: string;
// };

// const ReceiptSettings: React.FC = () => {
//   const { control, setValue, watch } = useForm<ReceiptFormValues>({
//     defaultValues: {
//       shopName: "",
//       shopAddress: "",
//       shopPhone: "",

//       showCustomerName: true,
//       showPhone: true,
//       showDiscount: true,
//       showPaymentType: true,

//       footerMessage: "Thank you for shopping!",
//       templateType: "default",
//     },
//   });

//   const values = watch();

//   const handleToggle = (
//     key:
//       | "showCustomerName"
//       | "showPhone"
//       | "showDiscount"
//       | "showPaymentType"
//   ) => {
//     setValue(key, !values[key]);
//   };

//   return (
//     <Paper sx={{ p: 3, borderRadius: 3 }}>
//       <Typography variant="h6" fontWeight="bold" mb={2}>
//         Receipt Settings
//       </Typography>

//       <Divider sx={{ mb: 2 }} />

//       <Grid container spacing={2}>
//         {/* Shop Info */}
//         <Grid item xs={12}>
//           <WSTextField
//             id="shopName"
//             name="shopName"
//             label="Shop Name"
//             control={control}
//             setValue={setValue}
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <WSTextField
//             id="shopAddress"
//             name="shopAddress"
//             label="Shop Address"
//             control={control}
//             setValue={setValue}
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <WSTextField
//             id="shopPhone"
//             name="shopPhone"
//             label="Shop Phone"
//             control={control}
//             setValue={setValue}
//             textIcon="Call"
//           />
//         </Grid>

//         {/* Toggles */}
//         <Grid item xs={12} sm={6}>
//           <FormControlLabel
//             control={
//               <Switch
//                 checked={values.showCustomerName}
//                 onChange={() => handleToggle("showCustomerName")}
//               />
//             }
//             label="Show Customer Name"
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <FormControlLabel
//             control={
//               <Switch
//                 checked={values.showPhone}
//                 onChange={() => handleToggle("showPhone")}
//               />
//             }
//             label="Show Phone"
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <FormControlLabel
//             control={
//               <Switch
//                 checked={values.showDiscount}
//                 onChange={() => handleToggle("showDiscount")}
//               />
//             }
//             label="Show Discount"
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <FormControlLabel
//             control={
//               <Switch
//                 checked={values.showPaymentType}
//                 onChange={() => handleToggle("showPaymentType")}
//               />
//             }
//             label="Show Payment Type"
//           />
//         </Grid>

//         {/* Footer */}
//         <Grid item xs={12}>
//           <WSTextField
//             id="footerMessage"
//             name="footerMessage"
//             label="Footer Message"
//             control={control}
//             setValue={setValue}
//           />
//         </Grid>
//       </Grid>
//     </Paper>
//   );
// };

// export default ReceiptSettings;


import React from "react";
import {
  Paper,
  Typography,
  Grid,
  Switch,
  FormControlLabel,
  Divider,
} from "@mui/material";
import WSTextField from "../../Components/TextBox/WSTextBox";

const ReceiptSettings = ({ control, watch, setValue }: any) => {
  const values = watch();

  const toggle = (key: string) => {
    setValue(key, !values[key]);
  };

  return (
    <Paper sx={{ p: 3, borderRadius: 3 }}>
      <Typography variant="h6" mb={2}>
        Receipt Settings
      </Typography>

      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSTextField
            id="title"
            name="title"
            label="Title"
            control={control}
            setValue={setValue}
          />
        </Grid>

        <Grid item xs={12}>
          <WSTextField
            id="shopName"
            name="shopName"
            label="Shop Name"
            control={control}
            setValue={setValue}
          />
        </Grid>

        <Grid item xs={12}>
          <WSTextField
            id="shopAddress"
            name="shopAddress"
            label="Shop Address"
            control={control}
            setValue={setValue}
          />        </Grid>

        <Grid item xs={12}>
          <WSTextField
            id="shopPhone"
            name="shopPhone"
            label="Shop Phone"
            control={control}
            setValue={setValue}
          />        </Grid>

        <Grid item xs={12} sm={6}>
          <WSTextField
            id="paperSize"
            name="paperSize"
            label="Paper Size"
            control={control}
            setValue={setValue}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <WSTextField
            id="widthPx"
            name="widthPx"
            label="Width (px)"
            control={control}
            setValue={setValue}
          />        </Grid>

        <Grid item xs={12} sm={6}>
          <WSTextField
            id="fontSize"
            name="fontSize"
            label="Font Size"
            control={control}
            setValue={setValue}
          />        </Grid>

        <Grid item xs={12} sm={6}>
          <WSTextField
            id="headerFontSize"
            name="headerFontSize"
            label="Header Font Size"
            control={control}
            setValue={setValue}
          />        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={<Switch checked={values.showCustomerName} onChange={() => toggle("showCustomerName")} />}
            label="Show Customer Name"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={<Switch checked={values.showPhone} onChange={() => toggle("showPhone")} />}
            label="Show Phone"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={<Switch checked={values.showDiscount} onChange={() => toggle("showDiscount")} />}
            label="Show Discount"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={<Switch checked={values.showPaymentType} onChange={() => toggle("showPaymentType")} />}
            label="Show Payment Type"
          />
        </Grid>

        <Grid item xs={12}>
          <WSTextField
            id="footerMessage"
            name="footerMessage"
            label="Footer Message"
            control={control}
            setValue={setValue}
          />        </Grid>
      </Grid>
    </Paper>
  );
};

export default ReceiptSettings;